import reducers from './autocompleteReducers';

export default reducers;



// WEBPACK FOOTER //
// ./src/state/reducers/autocomplete/index.js